$crisp.push(["on", "session:loaded", function () {
    axios.get('/api/user').then(function (response) {
        $crisp.push(["set", "user:email", response.data.user.email]);
        $crisp.push(["set", "user:nickname", [response.data.user.username]]);
        $crisp.push(["set", "user:avatar", [response.data.user.avatar]]);
        // $crisp.push(["set", "user:data", [['registered_at',response.data.user.registered_at]],['url',response.data.user.url],['designs',response.data.user.designs]]);
        $crisp.push(["set", "session:data", [[
            ["url", response.data.user.url],
            ['designs', response.data.user.designs],
            ['roles', JSON.stringify(response.data.roles)],
            ["registered_at", response.data.user.registered_at]
        ]]]);
    }).catch(function (error) {
        console.error('Getting user data : ' + error);
    })
}]);
// Set user email, async-safe

